<template>
	<div id="rootVM" v-cloak>
		<div id="pageTitle">
			<b>발생이력</b>
		</div>
		<!-- Search -->
		<div class="panel panel-flat">
			<div class="panel-body">
				<form @submit.prevent="search" @keyup.enter.prevent="search">
					<div class="row">
						<!-- 기간 -->
						<div class="col-md-4">
							<div class="form-group">
								<select2 v-model="searchVM.occurDtm" :options="options.occurDtmOption"></select2>
								<input type="date" class="form-control" v-model="searchVM.occurDtmStat" required />
								&nbsp;~&nbsp;
								<input type="date" class="form-control" v-model="searchVM.occurDtmEnd" :min="searchVM.occurDtmStat" :max="maxDay" required />
							</div>
						</div>
						<!-- 시간대 -->
						<div class="col-md-3">
							<div class="form-group">
								<input type="time" class="form-control" v-model="searchVM.occurTimeStat" required />
								&nbsp;~&nbsp;
								<input type="time" class="form-control" v-model="searchVM.occurTimeEnd" :min="searchVM.occurTimeStat" required />
							</div>
						</div>
						<!-- CCTV -->
						<div class="col-md-2" style="width: 250px; margin-right: 10px">
							<div class="form-group" v-if="cctvChoiceMethod == 'cctvSelect'">
								<label style="width: 73px">{{ detailsFieldMap.searchCctv }}</label>
								<div class="select-wrapper">
									<select2 v-model="searchVM.cctvInstallPlaceContSelect">
										<option value="">전체</option>
										<option v-for="item in options.cctvOptions" :key="item.cctvInstallPlaceCont" :value="item.cctvInstallPlaceCont">
											{{ item.cctvInstallPlaceCont }}
										</option>
									</select2>
								</div>
							</div>
							<div class="form-group" v-if="cctvChoiceMethod == 'cctvText'">
								<label style="width: 73px">{{ detailsFieldMap.searchCctv }}</label>
								<input type="text" class="form-control" :placeholder="detailsFieldMap.searchCctv" v-model="searchVM.cctvInstallPlaceContText" />
							</div>
						</div>
						<div class="col-md-1" style="width: 300px; margin-left: -30px; display: flex">
							<div class="form-group" style="width: 80px">
								<label style="margin-top: 8px">이력</label>
								<div class="checkbox" style="margin-bottom: 25px">
									<input type="checkbox" id="check" v-model="searchVM.isCheckedCctvAll" />
								</div>
							</div>
							<div style="margin-left: 20px">
								<span>
									(CCTV 검색어 입력 방법)
									<div style="margin-left: 25px">
										<input type="radio" v-model="cctvChoiceMethod" name="cctvSelect" value="cctvSelect" checked />
										<label for="cctvSelect">선택</label>
										<input type="radio" v-model="cctvChoiceMethod" name="cctvText" value="cctvText" />
										<label for="cctvText">텍스트</label>
									</div>
								</span>
							</div>
						</div>
					</div>
					<div class="row">
						<!-- 현장 -->
						<div class="col-md-2" style="width: 250px">
							<div class="form-group">
								<label>{{ detailsFieldMap.searchSite }}</label>
								<div class="select-wrapper">
									<select2 v-model="searchVM.siteId" :disabled="isDisabledSearchSite">
										<option value="">전체</option>
										<option v-for="item in options.siteOptions" :key="item.siteId" :value="item.siteId">
											{{ item.siteNm }}
										</option>
									</select2>
								</div>
							</div>
						</div>
						<!-- 구분 -->
						<div class="col-md-2">
							<div class="form-group">
								<label>{{ detailsFieldMap.searchEventType }}</label>
								<div class="select-wrapper">
									<select2 v-model="searchVM.eventType">
										<option value="">전체</option>
										<option v-for="item in options.eventTypeOption" :key="item.value" :value="item.value">
											{{ item.text }}
										</option>
									</select2>
								</div>
							</div>
						</div>
						<!-- 상태 -->
						<div class="col-md-2">
							<div class="form-group">
								<label>{{ detailsFieldMap.searchVideoDangerActnDvsnCd }}</label>
								<div class="select-wrapper">
									<select2 v-model="searchVM.videoActnDvsnCd">
										<option value="">전체</option>
										<option v-for="item in options.videoActnDvsnCdOption" :key="item.value" :value="item.value">
											{{ item.text }}
										</option>
									</select2>
								</div>
							</div>
						</div>
						<!-- 대상물명 -->
						<div class="col-md-3" style="width: 250px">
							<div class="form-group">
								<label>{{ detailsFieldMap.searchObject }}</label>
								<div class="select-wrapper">
									<select2 v-model="searchVM.objectId">
										<option value="">전체</option>
										<option v-for="item in options.objectOptions" :key="item.objectId" :value="item.objectId">
											{{ item.objectNm }}
										</option>
									</select2>
								</div>
							</div>
						</div>

						<!-- 조치사항 -->
						<div class="col-md-3" style="width: 250px">
							<div class="form-group">
								<label>{{ detailsFieldMap.searchTarget }}</label>
								<div class="select-wrapper">
									<select2 v-model="searchVM.targetId" :disabled="searchVM.objectId == ''">
										<option value="">전체</option>
										<option v-for="item in options.targetOptions" :key="item.targetId" :value="item.targetId">
											{{ item.targetNm }}
										</option>
									</select2>
								</div>
							</div>
						</div>

						<!-- 조회 버튼 -->
						<div class="mb-10 text-right" style="float: right; margin: 0">
							<button type="submit" class="btn btn-labeled bg-primary">
								<b><i class="icon-search4"></i></b>
								조회
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>

		<!-- Grid -->
		<div>
			<KendoGrid
				ref="grid"
				:auto-bind="false"
				:api-url="apiUrl.pageListApi"
				:columns="gridColumns"
				:apply-search-condition="applySearchStateOnGridLoad"
				@selected-row-item-changed="selectedRowItemChanged"
			></KendoGrid>
		</div>
		<div class="mt-10 mb-15 text-right"></div>
		<div id="detailFrames" class="form-horizontal form-validate-jquery" ref="detailFrames" v-show="isEditMode">
			<div class="panel panel-flat">
				<div class="panel-heading">
					<h6 class="panel-title">
						<b>상세 정보 ({{ detailsItem.cctvInstallPlaceCont }})</b>
					</h6>
					<div class="btn-group btn-group-toggle" data-toggle="buttons">
						<label :class="`btn btn-primary ${isCheckedToggleVideo ? '' : 'active'}`" @click="toggleFrameVideo(false)">
							<input type="radio" name="options" id="option1" autocomplete="off" />
							프레임
						</label>
						<label :class="`btn btn-primary ${isCheckedToggleVideo ? 'active' : ''}`" @click="toggleFrameVideo(true)">
							<input type="radio" name="options" id="option2" autocomplete="off" />
							비디오
						</label>
					</div>
					<i class="fa-solid fa-chevron-up" @click="pannelHidden" />
				</div>

				<div class="panel-body">
					<!-- <div class="border" style="width: 1020px; height: 530px; overflow-y: auto"> -->
					<div v-if="!isCheckedToggleVideo" class="border" style="width: 1020px; height: auto; max-height: 800px; overflow-y: auto">
						<div style="display: inline-block; text-align: center" v-for="(item, index) in detailsItem.slicedOccurFrameImgOutVOs" :key="index">
							<img
								:src="item.imgData"
								style="width: 200px; height: 112.5px; object-fit: contain; padding: 5px; display: block; cursor: pointer"
								@click="occurImgClicked(item, index)"
							/>
							<span>{{ item.imgSaveDtm }}</span>
						</div>
					</div>
					<div
						v-if="isCheckedToggleVideo && detailsItemVideo.occurObjectSeq"
						class="border"
						style="width: 1020px; height: auto; max-height: 800px; overflow-y: auto"
					>
						<video-box
							:key="keyForRerendering"
							:detailsItem="detailsItemVideo"
							:urlFlag="detailsItemVideo.videoWarnActnDvsnCd ? 'warn-work' : 'danger'"
							:imgWrapper="
								detailsItemVideo.videoWarnActnDvsnCd ? detailsItemVideo.inqWarnWorkOccurImgOutVOs : detailsItemVideo.inqDangerOccurFrameImgOutVOs
							"
						></video-box>
					</div>
					<div class="border" style="width: 358px; margin: 0 0 20px 20px; margin-left: auto">
						<div class="rhtBox" style="height: auto">
							<div style="display: inline-block; width: 100%"><h3>대상물</h3></div>
							<div
								class="row"
								style="width: 100%; min-height: 135px; margin: 0px"
								v-for="(targets, object) in dangerOccurObjectsAndTargets"
								:key="object"
							>
								<div style="font-size: 17px; margin-bottom: 10px; padding-left: 15px; margin-top: 15px; margin-left: 20px">{{ object }}</div>
								<li v-for="target in targets" :key="target" style="margin-left: 20px">
									{{ target }}
								</li>
							</div>
							<div class="objectBox" v-for="(object, index) in detailsItem.objectNmsAllSequences" :key="index">
								<div style="font-size: 17px; margin-bottom: 10px; padding-left: 15px; margin-top: 15px; margin-left: 20px">
									{{ object }}
								</div>
								<div class="border-bottom" style="margin-top: 60px"></div>
							</div>
						</div>
						<div class="rhtBox">
							<div><h3>작업 이력</h3></div>
							<div v-for="(item, index) in detailsItem.inqDangerOccurActnOutVOs" :key="index">
								<div style="margin-top: 15px; margin-bottom: 15px; margin-left: 20px; padding-left: 15px">
									{{ item.actnDtm }} : {{ item.videoDangerActnDvsnCdNm }}
								</div>
							</div>
							<div v-for="(item, index) in detailsItem.inqWarnOccurActnOutVOs" :key="index">
								<div style="margin-top: 15px; margin-bottom: 15px; margin-left: 20px; padding-left: 15px">
									{{ item.actnDtm }} : {{ item.videoWarnActnDvsnCdNm }}
								</div>
							</div>
						</div>
						<div class="border-bottom" style="margin-bottom: 20px"></div>
						<div style="display: flex; margin: 10px 0px">
							<button class="btn bg-primary" style="flex: 1; margin: 0px 5px" @click.stop="misdetection" v-if="!detailsItem.misdectDtm">오탐</button>
							<button class="btn bg-primary" style="flex: 1; margin: 0px 5px" @click.stop="deMisdetection" v-if="detailsItem.misdectDtm">
								오탐 해제
							</button>
							<button class="btn bg-primary" style="flex: 1; margin: 0px 5px" @click.stop="popupExemplaryCase" v-if="menuGubun != '01'">
								모범사례
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 모범사례 -->
		<div ref="popupExemplaryCase" class="modal">
			<div class="modal-content">
				<div action="#" class="form-horizontal form-validate-jquery popupEx">
					<div>
						<div class="panel-heading">
							<input type="button" id="ex-caseBtn" value="사진" />
							<input type="button" id="lawBtn" value="관련법령" />
							<span @click="popupExemplaryCaseClose" class="close">&times;</span>
						</div>
						<div class="panel-body">
							<div class="panel panel-flat exCase row">
								<div class="col-md-9" align="center">
									<img :src="imageSrc" style="max-width: 100%; height: 600px; object-fit: contain" />
								</div>
								<div class="col-md-3">
									<!-- 파일 데이터를 보여줄 테이블 -->
									<div class="table-wrapper" ref="tableWrapperImage">
										<table class="table">
											<thead>
												<tr>
													<th>일자</th>
													<th>파일명</th>
												</tr>
											</thead>
											<tbody>
												<tr
													v-for="(row, index) in detailsItem.images"
													:key="index"
													@click="clickRowImage(index)"
													v-bind:class="{ active: activeImageForExemplaryCase == index }"
												>
													<td>{{ row.regDtm.slice(0, 10) }}</td>
													<td colspan="2">{{ row.imgOriNm }}</td>
												</tr>
												<tr empty>
													<td colspan="3">추가된 이미지가 없습니다</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
							<div class="panel panel-flat law-panel" id="law-panel">
								<div class="panel-body">
									<div class="row" style="padding-left: 10px">
										<div class="col-md-9">
											<div>
												<label style="width: 70px; font-size: 18px">법조항</label>
												<input class="form-control" type="text" v-model="detailsItem.lawClss" :disabled="true" style="margin-bottom: 15px" />
											</div>
											<label style="font-size: 18px">법령</label>
											<textarea class="form-control" v-model="detailsItem.stte" disabled="true" style="margin-bottom: 15px"></textarea>
										</div>
										<div class="col-md-3">
											<!-- 법령 데이터를 보여줄 테이블 -->
											<div class="table-wrapper" ref="tableWrapperLaw">
												<table class="table">
													<thead>
														<tr algin="center">
															<th>일자</th>
															<th>법조항</th>
														</tr>
													</thead>
													<tbody>
														<tr
															v-for="(row, index) in detailsItem.laws"
															:key="index"
															:id="'laws_' + index"
															@click="clickRowLaw(index)"
															v-bind:class="{ active: activeLaw == index }"
														>
															<td>{{ row.regDtm.slice(0, 10) }}</td>
															<td colspan="2" align="left">{{ row.lawClss }}</td>
														</tr>
														<tr empty>
															<td colspan="3">추가된 법령이 없습니다</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<event-details-popup :show="showDetailsPopup" :detailsItem="detailsItem" :onClose="onCloseDetailsPopup" :imgIndex="activeImage" />
	</div>
</template>

<script>
import KendoGrid from '@/components/KendoGrid';
import Select2 from '@/components/Select2';
import VideoBox from '@/components/VideoBox';
import extend from 'extend';
import moment from 'moment';
import _ from 'lodash';
import apiIndex from '../../api/index';
import EventDetailsPopup from '@/components/EventDetailsPopup';

const exemplaryCaseUrl = apiIndex.exemplaryCase;
const dangerOccurUrl = apiIndex.dangerOccur;
const warnWorkOccurUrl = apiIndex.warnWorkOccur;
const dangerWarnWorkOccurUrl = apiIndex.dangerWarnWorkOccur;

let axiosExtention;

export default {
	components: {
		KendoGrid,
		select2: Select2,
		VideoBox,
		EventDetailsPopup,
	},
	data: () => ({
		pageParam: null,
		apiUrl: {
			pageListApi: dangerWarnWorkOccurUrl.inqDangerWarnWorkOccur,
		},
		searchVM: {},
		// 상세 select options
		detailsOptions: {},
		// 검색 select options
		searchOptions: {},
		// 적용된 검색조건
		searchState: {},
		gridColumns: [
			{
				field: 'eventType',
				title: '구분',
				width: '9%',
				align: 'center',
			},
			{
				field: 'cdNm',
				title: '상태',
				width: '9%',
				align: 'center',
			},
			{ field: 'occurDtm', title: '발생 시간', align: 'center', width: '12%' },
			{ field: 'dangerLiftDtm', title: '해제 시간', align: 'center', width: '12%' },
			{ field: 'siteNm', title: '현장명', width: '12%' },
			{ field: 'cctvInstallPlaceCont', title: 'CCTV', width: '16%' },
			{ field: 'thumbNailImgByte', title: '이미지', width: '10%', thumbNail: true },
			{ field: 'objectNm', title: '대상물', width: '10%' },
			{ field: 'targetNm', title: '조치사항', width: '10%' },
		],
		detailsFieldMap: {
			searchSite: '현장',
			searchCctv: 'CCTV',
			searchEventType: '구분',
			searchVideoDangerActnDvsnCd: '상태',
			searchObject: '대상물명',
			searchTarget: '조치사항명',
		},
		//상세편집 원본
		detailsItemOriginal: {},
		//상세편집 수정본
		detailsItem: {},
		detailsItemVideo: {},
		popupImg: {},
		options: {
			siteOptions: [],
			cctvOptions: [],
			objectOptions: [],
			targetOptions: [],
			videoDangerActnDvsnCdOption: [],
			occurDtmOption: [],
		},
		isDisabledSearchSite: true,
		activeImage: 0,
		dangerOccurObjectsAndTargets: {},
		dangerZoneAtSequenceMap: {},
		sequenceMapForDetail: {},
		warnWorkOccurSequenceMap: {},
		outFramesDetailData: {},
		imageSrc: '/images/noimage.png',
		activeImageForExemplaryCase: 0,
		activeLaw: 0,
		menuGubun: '',
		curDangerDvsnCd: null,
		//occurDtmEnd의 지정 가능한 최대 일자(occurDtmStat 기준으로 생성)
		maxDay: '',
		forRerendering: 0,
		cctvChoiceMethod: 'cctvSelect',
		scrollDirection: '',
		isCheckedToggleVideo: false,
		keyForRerendering: 0,
		showDetailsPopup: false,
	}),
	created() {
		this.pageParam = JSON.parse(sessionStorage.getItem('dangerWarnWorkOccurPageParam'));
		if (!this.pageParam) location.href = apiIndex.mainUrl;
		this.searchVM = {
			occurDtm: '01',
			occurDtmStat: this.pageParam.strtDate || moment().format('YYYY-MM-DD'),
			occurDtmEnd: this.pageParam.endDate || moment().format('YYYY-MM-DD'),
			occurTimeStat: this.pageParam.strtTime || '00:00',
			occurTimeEnd: this.pageParam.endTime || '23:59',
			siteId: this.pageParam.siteId === 'ALL' ? '' : this.pageParam.siteId || this.pageParam.loginUserSiteId,
			cctvInstallPlaceContSelect: '',
			cctvInstallPlaceContText: '',
			objectId: this.pageParam.objectId || '',
			targetId: this.pageParam.targetId || '',
			videoActnDvsnCd: this.pageParam.videoDangerActnDvsnCd || this.pageParam.videoWarnActnDvsnCd,
			isCheckedCctvAll: false,
			eventType: this.pageParam.eventType || '',
		};

		const commonCodeList = JSON.parse(sessionStorage.getItem('commonCodeList'));

		this.options = {
			siteOptions: this.pageParam.siteOptions,
			cctvOptions: this.pageParam.cctvOptions,
			objectOptions: this.pageParam.objectOptions,
			targetOptions: this.pageParam.targetOptions,
			videoActnDvsnCdOption: commonCodeList.filter(item => item.grpCd == 'video_actn_dvsn_cd'),
			videoDangerActnDvsnCdOption: commonCodeList.filter(item => item.grpCd == 'video_danger_actn_dvsn_cd'),
			videoWarnActnDvsnCdOption: commonCodeList.filter(item => item.grpCd == 'video_warn_actn_dvsn_cd'),
			warnWorkOptions: this.pageParam.warnWorkOptions,
			occurDtmOption: commonCodeList.filter(item => item.grpCd == 'danger_dtm'),
			eventTypeOption: [
				{
					value: 'danger',
					text: '위험',
				},
				{
					value: 'warnWork',
					text: '주의',
				},
			],
		};

		axiosExtention = this.$jarvisExtention.axiosExtention;

		this.isDisabledSearchSite = this.pageParam.loginUserRolecd === '00' ? false : true;
	},
	mounted() {
		this.menuGubun = process.env.VUE_APP_MENU_GUBUN;
		this.search();
	},
	computed: {
		isEditMode() {
			return !_.isEmpty(this.detailsItem) && !_.isEmpty(this.detailsItemOriginal);
		},
		isCreateMode() {
			return !_.isEmpty(this.detailsItem) && _.isEmpty(this.detailsItemOriginal);
		},
		validationRule() {
			var rule = null;
			if (this.isEditMode) {
				rule = this.detailsValidationRule.edit;
			} else {
				rule = this.detailsValidationRule.create;
			}
			return { detailsItem: rule };
		},
	},
	watch: {
		detailsItem(newVal) {
			this.$validator.reset(); //Validation상태 초기화
			//details활성화 시 스크롤 이동처리
			if (!_.isEmpty(newVal)) {
				this.$nextTick(function () {
					window.scrollTo({ top: this.getDetailsFormPositionForScrolling(), behavior: 'smooth' });
				});
			}
		},
		'searchVM.siteId': {
			handler(value, oldValue) {
				if (oldValue !== undefined) {
					this.$axios
						.post(dangerOccurUrl.inqDangerOccurCctvInfo, { siteId: this.searchVM.siteId, isCheckedCctvAll: this.searchVM.isCheckedCctvAll })
						.then(
							function (r) {
								this.options.cctvOptions = r.data;
								this.searchVM.cctvInstallPlaceContSelect = '';
							}.bind(this),
						)
						.catch(axiosExtention.buildErrorHandler());
				}
			},
		},
		'searchVM.objectId': {
			handler(value, oldValue) {
				if (value != oldValue) {
					this.searchVM.targetId = '';
				}
				if (value != '' && value != null) {
					this.$axios
						.post(dangerOccurUrl.inqDangerOccurTargetInfo, { objectId: this.searchVM.objectId })
						.then(
							function (r) {
								this.options.targetOptions = r.data;

								if (this.pageParam.targetId) {
									this.searchVM.targetId = this.pageParam.targetId;
									this.search();
								}
							}.bind(this),
						)
						.catch(axiosExtention.buildErrorHandler());
				}
			},
		},
		'searchVM.isCheckedCctvAll': {
			handler() {
				this.$axios
					.post(dangerOccurUrl.inqDangerOccurCctvInfo, { siteId: this.searchVM.siteId, isCheckedCctvAll: this.searchVM.isCheckedCctvAll })
					.then(
						function (r) {
							this.options.cctvOptions = r.data;
						}.bind(this),
					)
					.catch(axiosExtention.buildErrorHandler());
			},
		},
		//조회기간을 최대 x개월 간으로 하기 위해
		'searchVM.occurDtmStat': {
			handler(value) {
				this.maxDay = moment(value).add(process.env.VUE_APP_MAX_MONTH, 'month').format('YYYY-MM-DD');
			},
		},
		cctvChoiceMethod: {
			handler(value, oldValue) {
				if (value != oldValue) {
					this.searchVM.cctvInstallPlaceContSelect = '';
					this.searchVM.cctvInstallPlaceContText = '';
				}
			},
		},
		// 활성화된 이미지가 변경됐을 때 이미지 데이터를 변경하기 위함
		activeImage(value, oldValue) {
			if (value > oldValue) {
				this.scrollDirection = 'down';
			} else if (value < oldValue) {
				this.scrollDirection = 'up';
			}

			this.popupImg = this.detailsItem.inqOccurFrameImgOutVOs[this.activeImage];
		},
	},
	methods: {
		getDetailsFormPositionForScrolling() {
			let element = document.getElementById('detailFrames');
			return element.getBoundingClientRect().top + window.scrollY;
		},
		// 모범사례 팝업에서 이미지 row를 클릭했을 때 이미지 불러오기
		clickRowImage(index) {
			this.activeImageForExemplaryCase = index;
			this.$axios.post(exemplaryCaseUrl.imgMain, { fileName: this.detailsItem.images[index].img }).then(response => {
				this.imageSrc = 'data:image/jpg;base64,' + response.data.imgVO.imgByte;
			});
		},
		// 모범사례 팝업에서 법령row를 클릭했을 때
		clickRowLaw(index) {
			this.activeLaw = index;
			this.detailsItem.lawClss = this.detailsItem.laws[index].lawClss;
			this.detailsItem.stte = this.detailsItem.laws[index].stte;
		},
		//검색적용
		search() {
			this.searchState = extend(true /*deep*/, {}, this.searchVM);
			this.loadGrid();
		},
		//그리드로드
		loadGrid() {
			this.closeDetails();
			this.$refs.grid.load();
		},
		//그리드로드시 검색조건적용
		applySearchStateOnGridLoad(param) {
			return extend(true /*deep*/, param, this.searchState || {});
		},
		//그리드에서 row를 선택했을 때 detailsItem 세팅용
		setDetailsItem(data, selectedRowItem) {
			this.detailsItemOriginal = $.extend(true, {}, data);
			this.detailsItem = $.extend(true, {}, data);
			this.detailsItem.cctvInstallPlaceCont = selectedRowItem.cctvInstallPlaceCont;
			this.detailsItem.objectId = selectedRowItem.objectId;
			this.detailsItem.targetId = selectedRowItem.targetId;
			this.detailsItem.cdNm = selectedRowItem.cdNm;
			this.detailsItem.misdectDtm = selectedRowItem.misdectDtm;
			this.detailsItem.occurObjectSeq = selectedRowItem.occurObjectSeq;
			this.detailsItem.dangerOccurObjectSeq = Number(selectedRowItem.occurObjectSeq);
			this.detailsItem.warnWorkOccurSeq = selectedRowItem.occurObjectSeq;
			this.detailsItem.dangerOccurDtm = selectedRowItem.occurDtm;
			this.detailsItem.dangerLiftDtm = selectedRowItem.dangerLiftDtm;
			this.detailsItem.videoActnDvsnCd = selectedRowItem.videoDangerActnDvsnCd || selectedRowItem.videoWarnActnDvsnCd;
			this.detailsItem.videoDangerActnDvsnCd = selectedRowItem.videoDangerActnDvsnCd;
			this.detailsItem.videoWarnActnDvsnCd = selectedRowItem.videoWarnActnDvsnCd;
			this.detailsItem.strtFrameImgSeq = selectedRowItem.strtFrameImgSeq;
			this.detailsItem.endFrameImgSeq = selectedRowItem.endFrameImgSeq;

			if (selectedRowItem.videoWarnActnDvsnCd) {
				this.detailsItem.inqOccurFrameImgOutVOs = this.detailsItem.inqWarnWorkOccurImgOutVOs;
				this.detailsItem.slicedOccurFrameImgOutVOs = this.detailsItem.inqWarnWorkOccurImgOutVOs.slice(0, 30);
			} else {
				this.detailsItem.inqOccurFrameImgOutVOs = this.detailsItem.inqDangerOccurFrameImgOutVOs;
				this.detailsItem.slicedOccurFrameImgOutVOs = this.detailsItem.inqDangerOccurFrameImgOutVOs.slice(0, 30);
			}
		},
		//이미지 데이터 세팅(프레임)
		setAllFramesToImageData() {
			const url = this.detailsItem.videoWarnActnDvsnCd ? warnWorkOccurUrl.imgOneWarnWorkOccur : dangerOccurUrl.imgOneDangerOccur;
			this.detailsItem.inqOccurFrameImgOutVOs.forEach(e => {
				this.$axios.post(url, { fileName: e.imgSaveFileNm }).then(response => {
					e.imgData = 'data:image/jpg;base64,' + response.data.imgByte;
				});
			});
		},
		//이미지 데이터 세팅(비디오)
		setAllFramesToImageDataVideo() {
			if (this.detailsItem.videoWarnActnDvsnCd) {
				// 주의
				this.detailsItemVideo.inqWarnWorkOccurImgOutVOs.forEach(e => {
					this.$axios.post(warnWorkOccurUrl.imgOneWarnWorkOccur, { fileName: e.imgSaveFileNm }).then(response => {
						e.imgData = 'data:image/jpg;base64,' + response.data.imgByte;
					});
				});
			} else {
				// 위험
				this.detailsItemVideo.inqDangerOccurFrameImgOutVOs.forEach(e => {
					this.$axios.post(dangerOccurUrl.imgOneDangerOccur, { fileName: e.imgSaveFileNm }).then(response => {
						e.imgData = 'data:image/jpg;base64,' + response.data.imgByte;
					});
				});
			}
		},
		setDangerActnDvsnCdNmByDvsnCd() {
			this.detailsItem.inqDangerOccurActnOutVOs.forEach((e, i) => {
				this.options.videoDangerActnDvsnCdOption.forEach(e1 => {
					if (e.videoDangerActnDvsnCd === e1.value) {
						if (e.misdectYn) {
							// 이력이 오탐이라면
							e.videoDangerActnDvsnCdNm = '오탐';
						} else {
							const beforeReleases = this.detailsItem.inqDangerOccurActnOutVOs.filter((item, j) => i > j && item.videoDangerActnDvsnCd === '04');
							// 해제 상태이고, 이전에 배치를 통해 해제된 적이 있으면 오탐 해제로 표시
							if (e.videoDangerActnDvsnCd === '04' && beforeReleases.length > 1) {
								e.videoDangerActnDvsnCdNm = '오탐 해제';
							} else {
								e.videoDangerActnDvsnCdNm = e1.text;
							}
						}
					}
				});
			});
		},
		setWarnActnDvsnCdNmByDvsnCd() {
			this.detailsItem.inqWarnOccurActnOutVOs.forEach((e, i) => {
				this.options.videoWarnActnDvsnCdOption.forEach(e1 => {
					if (e.videoWarnActnDvsnCd === e1.value) {
						if (e.misdectYn) {
							// 이력이 오탐이라면
							e.videoWarnActnDvsnCdNm = '오탐';
						} else {
							const beforeReleases = this.detailsItem.inqWarnOccurActnOutVOs.filter((item, j) => i > j && item.videoWarnActnDvsnCd === '04');
							// 해제 상태이고, 이전에 배치를 통해 해제된 적이 있으면 오탐 해제로 표시
							if (e.videoWarnActnDvsnCd === '04' && beforeReleases.length > 1) {
								e.videoWarnActnDvsnCdNm = '오탐 해제';
							} else {
								e.videoWarnActnDvsnCdNm = e1.text;
							}
						}
					}
				});
			});
		},
		// warnWorkOccurSequenceMap 맵에 시퀀스를 키로, 대상물을 세팅
		setObjectsToSequenceMap() {
			this.detailsItem.inqOccurFrameImgOutVOs.forEach(imgInfo => {
				this.detailsItem.inqWarnWorkFrameImgDetailVOs.forEach(e => {
					if (e.frameImgSeq == imgInfo.frameImgSeq && this.warnWorkOccurSequenceMap[imgInfo.frameImgSeq] == undefined) {
						this.$set(this.warnWorkOccurSequenceMap, imgInfo.frameImgSeq, new Array(e.objectNm));
					} else if (e.frameImgSeq == imgInfo.frameImgSeq) {
						this.setObjectNmstWithoutDuplication(e, this.warnWorkOccurSequenceMap);
					}
				});
			});
		},
		// dangerOccurObjectsAtSequenceMap 을 활용해서 대상물과 조치사항이 있는 시퀀스에 대상물과 조치사항을 세팅
		setObjectsToDetailsItem() {
			this.detailsItem.inqOccurFrameImgOutVOs.forEach(e => {
				this.$set(
					e,
					'objects',
					this.warnWorkOccurSequenceMap[e.frameImgSeq].map(objectNm => ({ objectNm })),
				);
			});
		},
		//그리드 선택 처리(프레임)
		selectedRowItemChanged(selectedRowItem) {
			this.$refs.detailFrames.classList.remove('conceal');
			this.detailsItem = {};
			this.dangerOccurObjectsAndTargets = {};
			this.dangerOccurObjectsAtSequenceMap = {};
			this.dangerZoneAtSequenceMap = {};

			if (!_.isEmpty(selectedRowItem)) {
				this.curDangerDvsnCd = selectedRowItem.videoDangerActnDvsnCd;
				this.detailsItemVideo = {}; // 비디오 데이터 초기화
				// 프레임/비디오 토글 초기화
				this.isCheckedToggleVideo = false;

				// API URL 세팅
				const url = selectedRowItem.videoWarnActnDvsnCd ? warnWorkOccurUrl.inqOneWarnWorkOccur : dangerOccurUrl.inqOneDangerOccur;

				// API 데이터 세팅
				if (selectedRowItem.videoWarnActnDvsnCd) {
					selectedRowItem.warnWorkOccurSeq = selectedRowItem.occurObjectSeq;
				} else {
					selectedRowItem.dangerOccurObjectSeq = Number(selectedRowItem.occurObjectSeq);
					selectedRowItem.dangerOccurDtm = selectedRowItem.occurDtm;
				}

				this.$axios
					.post(url, selectedRowItem)
					.then(
						function (response) {
							//그리드에서 row를 선택했을 때 detailsItem 세팅용
							this.setDetailsItem(response.data, selectedRowItem);
							//해당 위험이력 + 전후 이미지들에서 해당되는 조치대상 및 위험지역 세팅
							this.dangerOccurObjectsAndTargets = response.data.allSeqObjectsAndTargets;
							// this.objectAndDangerZoneMap = response.data.allSeqObjectsAndDangerZoneNms;
							//이미지 데이터 세팅
							this.setAllFramesToImageData();
							// dvsn코드를 통해 dvsnNm 설정
							if (response.data.videoWarnActnDvsnCd) {
								this.setWarnActnDvsnCdNmByDvsnCd();
								// warnWorkOccurSequenceMap 맵에 시퀀스를 키로, 대상물을 세팅
								this.setObjectsToSequenceMap();
								// warnWorkOccurSequenceMap 을 활용해서 대상물과 조치사항이 있는 시퀀스에 대상물을 세팅
								this.setObjectsToDetailsItem();
							} else {
								this.setDangerActnDvsnCdNmByDvsnCd();
							}

							this.keyForRerendering++;
						}.bind(this),
					)
					.catch(axiosExtention.buildErrorHandler());
			} else {
				//상세화면 닫기 (다시로드등으로 선택변경)
				this.closeDetails();
			}
		},
		// 비디오 선택 처리
		async selectedRowItemVideo() {
			// API URL 세팅
			const url = this.detailsItem.videoWarnActnDvsnCd ? warnWorkOccurUrl.inqOneWarnWorkOccurVideo : dangerOccurUrl.inqOneDangerOccurVideo;
			await this.$axios.post(url, this.detailsItem).then(response => {
				this.detailsItemVideo = extend(true, {}, response.data);
				this.detailsItemVideo.occurObjectSeq = this.detailsItem.occurObjectSeq;
				this.setAllFramesToImageDataVideo(); // 이미지 데이터 세팅
			});
		},
		//상세화면 닫기
		closeDetails() {
			this.detailsItemOriginal = {};
			this.detailsItem = {};
		},
		occurImgClicked(item, index) {
			this.activeImage = index;
			this.showDetailsPopup = true;
		},
		stopScrollingByKeydown(e) {
			if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].indexOf(e.code) > -1) {
				e.preventDefault();
			}
		},
		popupExemplaryCaseClose() {
			this.$refs.popupExemplaryCase.style.display = 'none';
		},
		popupImgClose() {
			// img popup 닫기
			this.$refs.popupImg.style.display = 'none';
			window.removeEventListener('keydown', this.stopScrollingByKeydown);
		},
		// 오탐
		misdetection() {
			const url = this.detailsItem.videoWarnActnDvsnCd ? warnWorkOccurUrl.updWarnWorkOccurMisdetection : dangerOccurUrl.dangerOccurMisdetection;

			if (this.detailsItem.misdectDtm) {
				alert('이미 오탐 처리되었습니다.');
			} else {
				this.$axios
					.post(url, this.detailsItem)
					.then(
						function () {
							this.loadGrid();
						}.bind(this),
					)
					.catch(axiosExtention.buildErrorHandler());
			}
		},
		// 오탐 해제
		deMisdetection() {
			const url = this.detailsItem.videoWarnActnDvsnCd ? warnWorkOccurUrl.updWarnWorkOccurDeMisdetection : dangerOccurUrl.dangerOccurDeMisdetection;

			if (!this.detailsItem.misdectDtm) {
				alert('오탐 상태가 아닙니다.');
			} else {
				this.$axios
					.post(url, this.detailsItem)
					.then(
						function () {
							this.loadGrid();
						}.bind(this),
					)
					.catch(axiosExtention.buildErrorHandler());
			}
		},
		popupExemplaryCase() {
			this.$axios
				.post(exemplaryCaseUrl.inqOneExemplaryCase, { objectId: this.detailsItem.objectId, targetId: this.detailsItem.targetId })
				.then(
					function (r) {
						this.detailsItem = $.extend(true /*deep*/, this.detailsItem, r.data);
						if (r.data.images.length) {
							this.activeImageForExemplaryCase = 0;
							this.imageSrc = 'data:image/jpg;base64, ' + r.data.firstImgVO.imgByte;
						} else {
							this.imageSrc = '/images/noimage.png';
						}

						if (r.data.laws.length != 0) {
							this.activeLaw = 0;
							this.detailsItem.lawClss = r.data.laws[0].lawClss;
							this.detailsItem.stte = r.data.laws[0].stte;
						}
						this.detailsItem;
						this.$refs.popupExemplaryCase.style.display = 'block';
					}.bind(this),
				)
				.catch(axiosExtention.buildErrorHandler());
		},
		pannelHidden() {
			this.$refs.detailFrames.classList.toggle('conceal');
		},
		toggleFrameVideo(isCheckedToggleVideo) {
			if (isCheckedToggleVideo === this.isCheckedToggleVideo) return;

			// 비디오 클릭 시 영상 정보 요청
			if (isCheckedToggleVideo && this.detailsItem.occurObjectSeq !== this.detailsItemVideo.occurObjectSeq) {
				// 같은 row를 보고 있을 땐 비디오 생성을 한 번만 하기 위해 프레임 occurSeq와 비디오 occurSeq가 다를 때에만 실행
				this.selectedRowItemVideo();
			}

			this.isCheckedToggleVideo = isCheckedToggleVideo;
		},
		onCloseDetailsPopup() {
			this.showDetailsPopup = false;
		},
	},
};
$(function () {
	$('#ex-caseBtn').click(function () {
		$('.exCase').show();
		$('#law-panel').hide();
		$('#ex-caseBtn').css({
			backgroundColor: 'white',
			borderBottom: '1px solid white',
			color: '#333333',
		});
		$('#lawBtn').css({
			backgroundColor: '#ebebeb',
			borderBottom: '1px solid #ddd',
			color: '#787878',
		});
	});
	$('#lawBtn').click(function () {
		$('#law-panel').show();
		$('.exCase').hide();
		$('#ex-caseBtn').css({
			backgroundColor: '#ebebeb',
			borderBottom: '1px solid #ddd',
			color: '#787878',
		});
		$('#lawBtn').css({
			backgroundColor: 'white',
			borderBottom: '1px solid white',
			color: '#333333',
		});
	});
});
</script>

<style>
*:focus {
	outline: none;
}

.select-wrapper > span {
	width: 190px !important;
}

.modal-content img {
	width: 100%;
	height: 100%;
	object-fit: contain;
}

/* .modal-content [photo] {
	cursor: pointer;
	border-radius: 4px;
	overflow: hidden;
}
.modal-content [photo] img {
	min-height: 120px;
	height: 120px;
}
.modal-content [photo].active {
	border: 5px solid #1878f3;
	box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 5px;
}

.modal-content [left] [photo] {
	margin-top: 20px;
} */

.modal-content [left] img {
	min-height: 120px !important;
	height: 120px !important;
}

.modal-content [photo] {
	cursor: pointer;
	border-radius: 4px;
	overflow: hidden;
}

.modal-content .active {
	border: 5px solid #1878f3;
	box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 5px;
}

.modal-content .activeImage {
	border: 5px solid #1878f3;
	box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 5px;
}

.modal-content [left] [photo] {
	margin-top: 20px;
}
[v-cloak] > * {
	display: none !important;
}

#rootVM > .panel {
	display: flex;
	padding: 40px 20px;
}

#rootVM > .panel .panel-body {
	margin: auto;
}

#rootVM > .panel .panel-body form .row .form-group {
	display: flex;
	align-items: center;
	margin: 0;
}

#rootVM > .panel .panel-body .row:first-child {
	display: flex;
	align-items: center;
	margin-bottom: 20px;
}

#rootVM > #detailFrames > .panel > .panel-heading .btn-group-toggle {
	margin-left: 20px;
}

#rootVM > #detailFrames > .panel > .panel-heading .btn-group-toggle .btn-primary {
	width: 60px;
	background: white;
	color: black;
	border: 1px solid #ddd;
	margin: 0;
}

#rootVM > #detailFrames > .panel > .panel-heading .btn-group-toggle .btn-primary:first-child {
	border-right: 0;
}

#rootVM > #detailFrames > .panel > .panel-heading .btn-group-toggle .btn-primary:last-child {
	border-left: 0;
}

#rootVM > #detailFrames > .panel > .panel-heading .btn-group-toggle .active {
	background: #0c7cd5;
	border: 1px solid #0c7cd5;
	color: white;
}

#rootVM > #detailFrames > .panel > .panel-heading .fa-chevron-up {
	cursor: pointer;
	margin-left: auto;
	font-size: 1.2em;
}

#rootVM > #detailFrames.conceal > .panel > .panel-heading .fa-chevron-up {
	transform: rotate(180deg);
}

#rootVM > #detailFrames .panel-body {
	display: flex;
}

#rootVM > #detailFrames.conceal .panel-body {
	display: none;
}

#rootVM > #detailFrames > .panel > .panel-heading {
	display: flex;
	align-items: center;
}

#rootVM #detailFrames > .panel > .panel-body .frame-images img {
	width: 200px;
	height: 112.5px;
	object-fit: contain;
	padding: 5px;
	display: block;
	cursor: pointer;
}

#rootVM > .panel .panel-body .row:last-child {
	display: flex;
}

#rootVM > .panel .panel-body .row:last-child .mb-10 {
	margin: 0 !important;
}

#rootVM > .panel .panel-body .row:last-child .select-wrapper > span {
	width: 150px !important;
}

#rootVM > .panel .panel-body .form-group {
	display: flex;
	align-content: center;
	justify-content: center;
}

#rootVM > .panel .panel-body .form-group label {
	width: 60%;
	margin-top: 5px;
	max-width: 130px;
}
#rootVM > .panel .panel-body .row:last-child .form-group label {
	width: unset;
}

#rootVM .popupImg img {
	width: 910px;
	max-height: 520px;
	object-fit: contain;
	display: block;
}

@media (min-width: 500px) and (max-width: 1800px) {
	.modal-content {
		background-color: #fefefe;
		margin: 1% auto;
		padding: 20px;
		border: 1px solid #888;
		width: 80%;
	}
	.modal-content [left] {
		padding: 0 15px;
		height: 85vh !important;
	}
	#popupImg {
		width: 55vw !important;
		max-height: 55vh !important;
	}
}

@media (min-width: 1801px) {
	.modal-content {
		background-color: #fefefe;
		margin: 4% auto;
		padding: 20px;
		border: 1px solid #888;
		width: 1300px;
		height: 800px;
	}
	.modal-content [left] {
		padding: 0 15px;
	}
}

/* The Modal (background) */
.modal {
	display: none; /* Hidden by default */
	position: fixed; /* Stay in place */
	z-index: 99; /* Sit on top */
	left: 0;
	top: 0;
	width: 100%; /* Full width */
	height: 100%; /* Full height */
	background-color: rgb(0, 0, 0); /*Fallback color */
	background-color: rgba(0, 0, 0, 0.4); /* //Black w/ opacity */
}

/* The Close Button */
.close {
	color: #aaa;
	float: right;
	font-size: 28px;
	font-weight: bold;
}
.close:hover,
.close:focus {
	color: black;
	text-decoration: none;
	cursor: pointer;
}
label {
	text-align: right;
	margin-right: 12px;
}
.panel-heading {
	padding-left: 20px !important;
}
.border {
	border-radius: 3px;
	border: 1px solid #ddd;
	float: left;
}
.border-bottom {
	width: 100%;
	margin: auto;
	border-bottom: 1px solid #ddd !important;
}
.objectBox {
	/* height: 135px; */
	min-height: 100px;
	/* height: auto; */
}
.rhtBox {
	/* height: 135px; */
	min-height: 135px;
	height: auto;
}
.rhtBox > div > h3 {
	/* background: #f9f9f9; */
	background: #e0e0e0;
}
.rhtBox .row {
	border-bottom: 1px solid #ddd !important;
}
h3 {
	font-weight: bold !important;
	margin: 0 !important;
	padding: 10px 10px 10px 15px;
}
.mBox {
	/* height: 135px; */
	height: 170px;
	border-radius: 3px;
	border: 1px solid #ddd;
	/* margin-bottom: 50px; */
	margin-bottom: 30px;
	margin-top: 30px;
}
.mBox > div:first-child {
	background: #f9f9f9;
}

/* .mBox > div:first-child {
	background: #e0e0e0;
} */
.mBox > div > h4 {
	background: #e0e0e0;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
}
.popupEx .law-panel .panel-body textarea {
	height: 300px;
	resize: none;
	margin-bottom: 20px;
}
.popupEx > div > .panel-heading {
	padding: 0;
	border: none;
	position: relative;
	z-index: 99;
	font-size: 15px;
	font-weight: bold;
}
.popupEx > div > .panel-body {
	padding: 0;
	margin: 0;
	position: relative;
	top: -1px;
}
#law-panel > .panel-body {
	padding: 20px;
	margin: 0;
	height: 640px;
}
#law-panel > .panel-body > .row {
	margin-top: auto;
}
.exCase {
	margin: 0;
	padding: 20px;
}
.popupEx > div > .panel-body > .law-panel {
	display: none;
	margin: 0;
	overflow-y: auto;
}
#ex-caseBtn,
#lawBtn {
	width: 90px;
	height: 35px;
	border: 1px solid #ddd;
	border-top-left-radius: 3px;
	border-top-right-radius: 3px;
}
#ex-caseBtn {
	background-color: white;
	border-bottom: 1px solid white;
	color: #333333;
}
#lawBtn {
	background-color: #ebebeb;
	border-bottom: 1px solid #ddd;
	color: #787878;
}

.plusEx > .panel > .panel-heading > div {
	display: flex;
}
.plusEx > .panel > .panel-heading > div > div {
	display: flex;
	align-items: center;
	margin-right: 40px;
}
.plusEx > .panel > .panel-heading > div > div > * {
	margin-right: 5px;
}
.plusEx > .panel > .panel-heading span {
	margin-right: 10px;
	min-width: 60px;
}

.plusEx > .panel > .panel-body > div {
	width: 690px;
	height: 568px;
	float: left;
	margin: 0;
	flex-direction: column;
}
.plusEx > .panel > .panel-body > div:last-child {
	float: right;
}

.plusEx .panel-heading {
	font-weight: bold;
}
.plusEx .panel-heading input {
	max-width: 160px;
}

.plusEx .law-panel .panel-body textarea {
	height: 222px;
	resize: none;
	margin-bottom: 15px;
}
.plusEx .law-panel .btn-wrapper {
	padding: 0;
	margin-bottom: 15px;
}
.plusEx .law-panel .btn-wrapper .btn {
	width: calc(50% - 5px);
	margin: 0;
}
.plusEx .law-panel .btn-wrapper .btn:last-child {
	float: right;
}
.plusEx tr.active td {
	background: #ddd;
}

.plusEx .panel-body .panel-flat .panel-body {
	display: flex;
	flex-direction: column;
}

.plusEx .table-wrapper {
	max-height: 200px;
	overflow-y: auto;
}

.modal .table-wrapper {
	max-height: 300px;
	overflow-y: auto;
}
.modal .table tbody tr:hover {
	cursor: pointer;
}

.table th {
	background: #eee;
	vertical-align: middle !important;
	font-weight: bold;
	text-align: center;
}
.panel-body .table th:first-child {
	width: 120px;
	text-align: center;
}

.table td {
	vertical-align: middle;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	max-width: 1px;
	text-align: left !important;
}
.panel-body .table td:first-child {
	text-align: center;
}
.panel-body .table td:last-child {
	text-align: center;
	width: 80px;
}

.table [empty] {
	display: none;
}
.table [empty] td {
	padding: 30px;
	font-size: 1.2em;
	text-align: center;
}
.table [empty]:first-child:last-child {
	display: table-row;
}

.btn-wrapper {
	width: 100%;
	clear: both;
	padding-bottom: 20px;
	padding-right: 20px;
}
.btn-wrapper .btn {
	margin-left: 10px;
}

.modal .search {
	text-align: center;
	margin-bottom: 15px;
}
.modal-header {
	padding: 0;
}
.close {
	right: 0 !important;
	top: 0 !important;
	font-size: 35px;
	margin-top: -15px !important;
	margin-right: -5px;
}
.modal-body {
	padding: 0;
	padding-top: 20px;
}
[type='search'] {
	display: inline-block;
	width: 330px;
	margin-right: 5px;
}
.modal-dialog > .modal-content {
	width: 400px;
	padding: 0;
	height: 182px;
}
</style>
